import './bml-news-relevant.scss';
const TEMPLATE = `
<section class="news-relevant-feed-content-main fade-up">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <h2 data-animate-child>Можливо буде цікаво</h2>
            </div>
        </div>

        <!-- Секція новин з анімованим контейнером -->
        <div class="news-section-feed" id="news-section" data-section="news-section-1" data-animate-child
             data-delay="400">
            <!-- Сюди завантажуватимуться блоки новин з новим дизайном -->
            <!-- Кожна новина матиме свій data-animate-child при динамічному завантаженні -->
        </div>

    </div>
</section>
`;

class BmlNewsRelevant extends HTMLElement {
    connectedCallback() {
        if (window.location.pathname.startsWith('/case/')) {
            this.style.display = 'none';
            return;
        }
        if (!this.innerHTML.trim()) this.innerHTML = TEMPLATE;
    }
}
customElements.define('bml-news-relevant', BmlNewsRelevant);
